class SmoothScroll {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const headerHeight = $('.l-header').outerHeight();
    const urlHash = location.hash;
    const btn  = document.querySelector(".l-header__hum");
    const humMenu  = document.querySelector(".humMenu");
    const html  = document.querySelector("html");

    if (window.matchMedia('(max-width: 767px)').matches) {
      if(urlHash) {
        $('body,html').stop().scrollTop(0);
        setTimeout(function(){
          const target = $(urlHash);
          const position = target.offset().top - headerHeight;
          $('body,html').stop().animate({scrollTop:position}, 500);
        }, 100);
      }
      $('a[href^="#"]').click(function(){
        const href= $(this).attr("href");
        const target = $(href);
        const position = target.offset().top + -10;
        btn.classList.remove("is-active")
        humMenu.classList.remove("is-active")
        html.classList.remove("is-hidden")
        $('body,html').stop().animate({
          scrollTop:position
        }, 500);
        return false;
      });

    } else if (window.matchMedia('(min-width:768px)').matches) {

      if(urlHash) {
        $('body,html').stop().scrollTop(0);
        setTimeout(function(){
          const target = $(urlHash);
          const position = target.offset().top - headerHeight;
          $('body,html').stop().animate({scrollTop:position}, 500);
        }, 100);
      }
      $('a[href^="#"]').click(function(){
        const href= $(this).attr("href");
        const target = $(href);
        const position = target.offset().top;
        btn.classList.remove("is-active")
        humMenu.classList.remove("is-active")
        html.classList.remove("is-hidden")
        $('body,html').stop().animate({
          scrollTop:position
        }, 500);
        return false;
      });
    }
  }
}
